import { FC, useMemo } from 'react';
import { MenuProps } from 'antd';
import { UnorderedListOutlined, DownOutlined } from '@ant-design/icons';
import { ProDropdown } from '../antd';
import SyncButton from '../SyncButton';
import { BaseBatchButtonGroupProps } from './interface';

/** 批量操作按钮组 */
const BatchGroup: FC<BaseBatchButtonGroupProps> = props => {
  const { groupText, buttonGroup, ...restProps } = props;

  const menu: MenuProps = useMemo(() => {
    const items: MenuProps['items'] = [];
    buttonGroup.forEach((item, index) => {
      const { text, ...restItem } = item;
      items.push({
        key: index,
        label: (
          <SyncButton {...restItem}>{text}</SyncButton>
        ),
      });
    });
    return {
      items,
    };
  }, [buttonGroup]);
  if (!buttonGroup || !buttonGroup?.length) return null;
  if (buttonGroup.length === 1) {
    const { text, ...restItem } = buttonGroup[0];
    return <SyncButton {...restItem}>{text}</SyncButton>;
  }
  return (
    <ProDropdown menu={menu}>
      <SyncButton icon={<UnorderedListOutlined />} {...restProps}>
        {groupText}
        <DownOutlined />
      </SyncButton>
    </ProDropdown>
  );
};

BatchGroup.defaultProps = {
  groupText: '批量操作',
};

export default BatchGroup;
